// export const sanitizeUploadKey = (key) =>
//   key.toLowerCase().replace(/_/g, '-')

export const sanitizeUploadKey = (key) => {
  if (!key) return "mold-unknown";
  return key
    .toString()
    .toLowerCase()
    .replace(/_/g, '-')      // underscores → hyphen
    .replace(/[^a-z0-9-]/g, ''); // strip anything not allowed
};
